import Home from '../page/Home/Home.jsx';
import FAQ from '../page/FAQ/FAQ.jsx';
import Theme from '../page/FAQ/Theme/Theme.jsx'
import Answer from '../page/Answer/Answer.jsx';


const routes =  [
  {
    path:'/',
    exact:true,
    component:Home
  },
  {
    path:'/Theme',
    component:Theme
  },
  {
    path:'/FAQ/:id',
    component:FAQ
  },
  {
    path:'/Answer',
    component:Answer
  }
]

export default routes;
